import React, { useState } from "react";
import Sidebar from "./Sidebar";

export default function MainLayout({ children }) {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <div style={styles.container}>
      <Sidebar collapsed={collapsed} onToggle={() => setCollapsed(!collapsed)} />
      <main
        style={{
          ...styles.main,
          marginLeft: collapsed ? 60 : 240,
        }}
      >
        {children}
      </main>
    </div>
  );
}

const styles = {
  container: {
    minHeight: "100vh",
    backgroundColor: "#0d1117",
  },
  main: {
    minHeight: "100vh",
    transition: "margin-left 0.3s ease",
    padding: "24px",
    backgroundColor: "#0d1117",
  },
};
